
import { Link } from "react-router-dom";
import React, { useEffect } from "react";
import CookieWrapper from "./cookieWrapper";

const Footer = () => {
  useEffect(() => {
    const loadChatWidget = () => {
      if (document.getElementById("BotPenguin-messenger-widget")) return;
      const script = document.createElement("script");
      script.id = "BotPenguin-messenger-widget";
      script.src = "https://cdn.botpenguin.com/botpenguin.js";
      script.defer = true;
      script.innerHTML = "61403a12a0fdab78e445b32a,613217abf5bb6e78fb678bce";
      document.body.appendChild(script);
    };

    const events = ["pointerdown", "keydown", "touchstart", "scroll"];
    const cleanupListeners = () => {
      events.forEach((eventName) => {
        window.removeEventListener(eventName, handleInteraction);
      });
    };
    const handleInteraction = () => {
      cleanupListeners();
      window.clearTimeout(timer);
      loadChatWidget();
    };
    const timer = window.setTimeout(loadChatWidget, 12000);

    events.forEach((eventName) => {
      window.addEventListener(eventName, handleInteraction, { once: true, passive: true });
    });

    return () => {
      cleanupListeners();
      window.clearTimeout(timer);
    };
  }, []);



  return (

    <>
      <footer className="footer">
        <div className="container footer-content">
          <div className="row">
            <div className="col-md-12 col-lg-3">
              <div className="footer-logo">
                <Link to="/">
                  <img src="/assets/images/heaer-logo.webp" alt="Logo" />
                </Link>
              </div>
            </div>
            <div className="col-md-12 col-lg-9">
              <div className="footer-right">
                <div className="top-section">
                  <div className="row row-social">
                    <div className="col-12 col-md-12 col-lg-7">
                      <div className="footer-top">
                        <div className="heading">
                          On The Path To Net-Zero: AWL India
                          <br />
                          Empowers Businesses To Align Sustainability With Economic Growth.
                        </div>
                        <Link to="/contact-us" className="btn-demo theme-btn">
                          Enquire Now
                        </Link>
                      </div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-5">
                      <div className="social-wrapper">
                        <p>Visit us at</p>
                        <div className="social-icons">
                          <ul>
                            <li>
                              <a href="https://www.facebook.com/awlindia" target="_blank" rel="noopener noreferrer"   >
                                <i className="fab fa-facebook-f"></i>
                              </a>
                            </li>
                            <li>
                              <a href="https://www.instagram.com/awlindia/" target="_blank" rel="noopener noreferrer" >
                                <i className="fab fa-instagram"></i>
                              </a>
                            </li>
                            <li>
                              <a href="https://x.com/awlindia" target="_blank" rel="noopener noreferrer"   >
                                <i className="fab fa-x-twitter"></i>
                              </a>
                            </li>
                            <li>
                              <a href="https://www.youtube.com/user/awlindia" target="_blank" rel="noopener noreferrer"   >
                                <i className="fab fa-youtube"></i>
                              </a>
                            </li>

                            <li>
                              <a href="https://www.linkedin.com/company/accelerated-warehousing-logistics-pvt--ltd-/" target="_blank" rel="noopener noreferrer"   >
                                <i className="fa-brands fa-linkedin-in"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="footer-menu">
                  <div className="row">
                    <div className="col-6 col-lg-3">
                      <div className="menu-item">
                        <div className="title">Solutions</div>
                        <ul>
                          {/* <li>
                            <Link to={"/"} >
                              SWIM</Link>
                          </li> */}
                          {/* <li>
                            <Link to={"/"}>
                              CRAWL</Link>
                          </li> */}
                          <li>
                            <Link to={"/swim"}  >
                              SWIM   </Link>
                          </li>

                          <li>
                            <Link to={"/drizzle"}  >
                              Drizzle   </Link>
                          </li>
                          <li>
                            <Link to={"/wision"} >
                              Wision</Link>
                          </li>

                          <li>
                            <Link to={"/aquarium"} >
                              Aquarium</Link>
                          </li>
                          <li>
                            <Link to={"/vaclogix"}  >
                              Vaclogix   </Link>
                          </li>

                          {/* <li>
                            <Link to={"/Doxinfinity"} >
                              Doxinfinity</Link>
                          </li> */}


                          {/* <li>
                            <Link to={"/"} >
                              VAWLT</Link>
                          </li> */}

                          {/* 
                          <li>
                          <Link to={"/"} >
                            CHAKSHU</Link>
                        </li>

                         <li>
                          <Link to={"/"} >
                            VACLOGIX</Link>
                        </li>

                        
                         <li>
                          <Link to={"/"} >
                            iPALLET</Link>
                        </li> */}


                        </ul>
                      </div>
                    </div>

                    <div className="col-6 col-lg-3">
                      <div className="menu-item">
                        <div className="title">Services</div>
                        <ul>
                          <li>
                            <Link to={"/warehousing "}>  Warehousing  </Link>
                          </li>
                          <li>
                            <Link to={"/order-fulfillment-logistics-services"}>  FulFillment  </Link>
                          </li>
                          <li>
                            <Link to={"/wide-cargo-logistics"}>  White Goods </Link>
                          </li>


                          <li>
                            <Link to={"/global-project-logistics"}>  Global Projects    </Link>
                          </li>

                          <li>
                            <Link to={"/industries-healthcare"}>  Pharma & Healthcare </Link>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="col-6 col-lg-3">
                      <div className="menu-item">
                        <div className="title">Company</div>
                        <ul>
                          <li>
                            <Link to={"/about-us"}>About</Link>
                          </li>
                          <li>
                            <Link to={"/career"}>  Career</Link>
                          </li>


                          <li>
                            <Link to={"/our-team"}>Our Team</Link>
                          </li>

                          <li>
                            <Link to={"/csr"}>Sustainability</Link>
                          </li>
                          <li>
                            <Link to={"/operation-exellence"}>Operation Exellence</Link>
                          </li>

                        </ul>
                      </div>
                    </div>
                    <div className="col-6 col-lg-3">
                      <div className="menu-item">
                        <div className="title"> Insights</div>
                        <ul>
                          <li><Link to="/blog-page">Blogs</Link></li>
                          <li><Link to="/gallery">Gallery</Link></li>
                          <li><Link to="/faq">Frequently Ask</Link></li>
                          <li><Link to="/press-release">Press Release</Link></li>
                          <li><Link to="/case-study">Case Studies</Link></li>

                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="copyright-text">
                  <div className="row row-margin align-items-center">
                    <div className="col-12 col-md-4 col-lg-5">
                      <div className="copyright-inner">
                        <p>© 2026 AWL INDIA  DESIGNED BY  <Link to="https://www.88gravity.com" target="_blank" rel="noopener noreferrer">88gravity</Link></p>
                      </div>
                    </div>
                    <div className="col-12 col-md-8 col-lg-7 text-md-right footer-bottom">
                      <div className="copyright-link">
                        <Link to="/privacy-policy">Privacy Policy</Link> |{" "}
                        <Link to="">Legal</Link> |{" "}
                        <Link to="/terms-and-conditions">Terms</Link> |{" "}
                        <Link to="#">Disclaimer</Link> |{" "}
                        <Link to="#">Sitemap</Link>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </footer>
      <CookieWrapper />
    </>
  );
};

export default Footer;
